import React from 'react';
import { CalendarClockIcon, Calculator, SmileIcon } from 'lucide-react';
import { motion } from 'framer-motion';
const features = [{
  title: 'Flexible Scheduling',
  description: "We work around your timeline. Evenings, weekends, or last-minute. We'll find a time that works for you.",
  icon: CalendarClockIcon
}, {
  title: 'Instant Online Quotes',
  description: 'No phone tag required. Fill out our detailed online form and get a personalized estimate within 24 hours.',
  icon: Calculator
}, {
  title: 'Service With a Smile',
  description: 'On time, careful with your property, and genuinely enjoyable to work with.',
  icon: SmileIcon
}];
export function Features() {
  return <section className="py-20 bg-white" data-id="element-21">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-22">
        <div className="text-center mb-16" data-id="element-23">
          <h2 className="text-3xl font-bold text-navy mb-4" data-id="element-24">
            Why Choose Justice Moving Co.
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-25">
            We built our business on reliability, hard work, and treating your
            items like our own.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12" data-id="element-26">
          {features.map((feature, index) => <motion.div key={feature.title} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="flex flex-col items-center text-center" data-id="element-27">
              <div className="w-16 h-16 bg-gold/10 rounded-full flex items-center justify-center mb-6" data-id="element-28">
                <feature.icon className="h-8 w-8 text-gold" data-id="element-29" />
              </div>
              <h3 className="text-xl font-bold text-navy mb-3" data-id="element-30">
                {feature.title}
              </h3>
              <p className="text-gray-600" data-id="element-31">{feature.description}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}